export default "__VITE_ASSET__DbG13Uyb__"